import React from 'react';

import classes from './PlayerPopup.module.css';

const PlayerPopup = props => {
  return (
    <div className={`${classes.popupVideos} ${!props.show ? classes.hidePlaer : classes.showPlayer}`}>
      <div
        className={`${classes.mask} ${!props.show ? classes.hidePlaer : classes.showPlayer} `}
        onClick={props.close} ></div>
        <span className={classes.close} onClick={props.close}>X</span>
      <div className={classes.videoContainer}>
        <video controls className={classes.video} allow="autoplay" autoPlay={true} >
          <source
            type="video/mp4"
            src={props.source}
          />
        </video>
      </div>
    </div>
  )
}

export default PlayerPopup;
